import PointCutPanel from "./pointCutPanel.container";

export default PointCutPanel;
